import React from 'react'

import { observer } from 'mobx-react'

import { IPermitTypeField } from '~/client/graph/types.generated'
import IPermitFieldsStore from '~/client/src/shared/models/IPermitFieldsStore'

import SitePermitCreationFormStore from '../../../WorkflowCreationForm.store'
import PermitFormFieldWrapper from '../../PermitFormFieldWrapper'
import WorkflowFormAddFieldButton from './WorkflowFormAddFieldButton'
import WorkflowFormFieldViewMode from './WorkflowFormFieldViewMode'

// localization: no text to translate

interface IProps<T> {
  typeField: IPermitTypeField
  fieldValues: T[]
  isViewMode: boolean
  isAddButtonShown: boolean
  parentInstanceId: string
  conditionalParentInstanceId: string
  parentValueIndex: number
  children: React.ReactNode

  store: SitePermitCreationFormStore
  fieldsStore: IPermitFieldsStore

  isViewModeIgnored?: boolean
  viewModeRenderer?(value: T): JSX.Element

  onAddFieldClick?(): void
}

function WorkflowFormCustomFieldValue<T>({
  children,
  fieldValues,
  typeField,
  isViewMode,
  parentInstanceId,
  conditionalParentInstanceId,
  parentValueIndex,
  fieldsStore,
  store,
  isViewModeIgnored,
  isAddButtonShown,
  viewModeRenderer,
  onAddFieldClick,
}: IProps<T>) {
  const conditionalFields = fieldsStore.getAvailableConditionalFields(
    typeField,
    0,
    parentInstanceId,
    parentValueIndex,
  )

  const isViewModeActive = isViewMode && !isViewModeIgnored

  return (
    <>
      {!isViewModeActive
        ? children
        : fieldValues.map((value, idx) => (
            <WorkflowFormFieldViewMode
              key={idx}
              value={value}
              typeField={typeField}
              isTitleShown={!idx}
              isPaddingAdded={!!conditionalFields.length}
              viewModeRenderer={viewModeRenderer}
            />
          ))}
      {conditionalFields.map(field => (
        <PermitFormFieldWrapper
          key={field.id}
          typeField={field}
          parentInstanceId={conditionalParentInstanceId}
          parentValueIndex={0}
          store={store}
          fieldsStore={fieldsStore}
          isViewMode={isViewMode}
        />
      ))}
      <WorkflowFormAddFieldButton
        isShown={isAddButtonShown}
        title={typeField.caption}
        onAddFieldClick={onAddFieldClick}
      />
    </>
  )
}

export default observer(WorkflowFormCustomFieldValue)
